import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {ApplicationConfig, provideAppInitializer} from '@angular/core'
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async'
import {provideRouter, withHashLocation} from '@angular/router'

import {routes} from './app.routes'
import {appInitializer} from './application/app-initializer'
import {authInterceptor} from './application/auth.interceptor'
import {LOCAL_STORAGE} from './application/constants'
import {responseInterceptor} from './application/response.interceptor'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        floatLabel: 'always', subscriptSizing: 'dynamic'
      }
    },
    {provide: LOCAL_STORAGE, useValue: localStorage},
    provideAppInitializer(() => appInitializer()),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([responseInterceptor, authInterceptor])),
    provideAnimationsAsync()
  ]
}
